/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LandingPageBlogCreateRequest = {
    bootCampCategory?: LandingPageBlogCreateRequest.bootCampCategory;
    sequence?: number;
    title?: string;
    contents?: string;
    forwardLink?: string;
    image?: Blob;
};

export namespace LandingPageBlogCreateRequest {

    export enum bootCampCategory {
        ALL = 'ALL',
        SEBFE = 'SEBFE',
        SEBBE = 'SEBBE',
        UUB = 'UUB',
        GMB = 'GMB',
        DOB = 'DOB',
        PMB = 'PMB',
        BEB = 'BEB',
        AIB = 'AIB',
    }


}

